import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PafGarantizadoComponent } from './PAF-garantizado.component';



@NgModule({
  declarations: [
    PafGarantizadoComponent
  ],
  imports: [
    CommonModule
  ], exports: [
    PafGarantizadoComponent
  ]
})
export class PafGarantizadoModule { }
